import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { visibleCustomFieldsLengthSelector } from '~/store/configViews/selectors';
import { canSeeCustomFields } from '~/utils/permissions/workspacePermissions';
import { useAirSelector } from '~/utils/ReduxUtils';

export const usePublicPermissionedVisibleCustomFieldsLength = () => {
  const { permissions } = usePublicPermissions();
  const canViewCustomFields = canSeeCustomFields(permissions);

  const visibleCustomFieldsLength = useAirSelector(visibleCustomFieldsLengthSelector);
  const permissionedVisibleCustomFieldsLength = canViewCustomFields ? visibleCustomFieldsLength : 0;

  return { permissionedVisibleCustomFieldsLength };
};
